import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const contentCell = {
    width: '50%',
    fontWeight: 'bold',
};

const contentCheckbox = {
    ...contentCell,
    padding: '10px',
};

const rowStyle = (changed) => ({
    cursor: 'pointer',
    backgroundColor: (theme) =>
        changed ? theme.palette.changed.main : theme.palette.background.paper,
    '&:hover': {
        backgroundColor: (theme) =>
            changed
                ? theme.palette.changed.main
                : theme.palette.hoverBackground.main,
    },
});

const noop = () => null;

const FieldItem = ({ profile, item, onChange }) => {
    const { editMode } = profile;
    const { type, label, field, format, editable, values, valuesMap } = item;

    const isText = type === 'text';
    const isCheckbox = type === 'checkbox';
    const isDropdown = type === 'dropdown';

    const value = profile.getCurrentValue(field);
    const error = profile.getError(field);
    const isChanged = profile.isChanged(field);

    const valueRaw = value != null ? value : '';
    const valueFmt = format(valueRaw);
    const canEdit = editable && editMode && onChange != null;

    const valueDropdown =
        isDropdown && canEdit && valuesMap[valueRaw] ? valueRaw : '';

    const handleChange = (!canEdit && noop) || ((e) => onChange(e, item));

    return (
        <TableRow sx={rowStyle(isChanged)}>
            <TableCell style={contentCell}>{label}</TableCell>
            <TableCell style={isCheckbox ? contentCheckbox : contentCell}>
                {isText && !canEdit && valueFmt}
                {isText && canEdit && (
                    <TextField
                        autoComplete="off"
                        fullWidth
                        name={field}
                        variant="standard"
                        onChange={handleChange}
                        value={valueFmt}
                        error={!!error}
                        helperText={error}
                    />
                )}
                {isCheckbox && (
                    <Checkbox
                        name={field}
                        size="small"
                        disabled={!editMode}
                        checked={!!valueFmt}
                        onChange={handleChange}
                    />
                )}
                {isDropdown && !canEdit && valueFmt}
                {isDropdown && canEdit && (
                    <TextField
                        select
                        name={field}
                        variant="standard"
                        onChange={handleChange}
                        value={valueDropdown}
                    >
                        {values.map((item, index) => (
                            <MenuItem key={index} value={item.value}>
                                {item.label}
                            </MenuItem>
                        ))}
                    </TextField>
                )}
            </TableCell>
        </TableRow>
    );
};

export default FieldItem;
